import { CharacterStyle } from 'js/config/consts';

export const SET_SEARCH_INPUT = 'SET_SEARCH_INPUT';
export const CLEAR_SEARCH_INPUT = 'CLEAR_SEARCH_INPUT';
export const SEARCH_IMAGES = 'SEARCH_IMAGES';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const RESET_SEARCH = 'RESET_SEARCH';
export const TOGGLE_SEARCH_FILTER = 'TOGGLE_SEARCH_FILTER';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const NAVIGATE_TO_CHARACTERS = 'NAVIGATE_TO_CHARACTERS';
export const NAVIGATE_BACK_FROM_CHARACTERS = 'NAVIGATE_BACK_FROM_CHARACTERS';
export const SELECT_CHARACTER = 'SELECT_CHARACTER';

export interface SetSearchInputAction {
  type: typeof SET_SEARCH_INPUT;
  searchInput: string;
}
export const setSearchInput = (searchInput: string): SetSearchInputAction => ({
  type: SET_SEARCH_INPUT,
  searchInput
});

export interface ClearSearchInputAction {
  type: typeof CLEAR_SEARCH_INPUT;
}
export const clearSearchInput = (): ClearSearchInputAction => ({
  type: CLEAR_SEARCH_INPUT
});

export interface SearchImagesAction {
  type: typeof SEARCH_IMAGES;
}
export const searchImages = (): SearchImagesAction => ({
  type: SEARCH_IMAGES
});

export interface SetSelectedCategoryAction {
  type: typeof SET_SELECTED_CATEGORY;
  selectedCategoryId: string;
}
export const setSelectedCategory = (selectedCategoryId: string): SetSelectedCategoryAction => ({
  type: SET_SELECTED_CATEGORY,
  selectedCategoryId
});

export interface ResetSearchAction {
  type: typeof RESET_SEARCH;
}
export const resetSearch = (): ResetSearchAction => ({
  type: RESET_SEARCH
});

export interface ToggleSearchFilterAction {
  type: typeof TOGGLE_SEARCH_FILTER;
  facetId: string;
  facetValue: string;
}

export const toggleSearchFilter = ({
  facetId,
  facetValue
}: Omit<ToggleSearchFilterAction, 'type'>): ToggleSearchFilterAction => ({
  type: TOGGLE_SEARCH_FILTER,
  facetId,
  facetValue
});

export interface ClearAllFiltersAction {
  type: typeof CLEAR_ALL_FILTERS;
}

export const clearAllFilters = (): ClearAllFiltersAction => ({
  type: CLEAR_ALL_FILTERS
});

export const LOAD_VISUAL_STYLES = 'LOAD_VISUAL_STYLES';
export const LOAD_VISUAL_STYLES_SUCCESS = 'LOAD_VISUAL_STYLES_SUCCESS';
export const LOAD_VISUAL_STYLES_FAILURE = 'LOAD_VISUAL_STYLES_FAILURE';

export interface VisualStyleItem {
  facetId: string;
  facetValue: string;
  iconKey: string;
  label: string;
  description: string;
}

export interface LoadVisualStylesAction {
  type: typeof LOAD_VISUAL_STYLES;
}
export const loadVisualStyles = (): LoadVisualStylesAction => ({
  type: LOAD_VISUAL_STYLES
});

export interface LoadVisualStylesSuccessAction {
  type: typeof LOAD_VISUAL_STYLES_SUCCESS;
  styles: VisualStyleItem[];
}
export const loadVisualStylesSuccess = (styles: VisualStyleItem[]): LoadVisualStylesSuccessAction => ({
  type: LOAD_VISUAL_STYLES_SUCCESS,
  styles
});

export interface LoadVisualStylesFailureAction {
  type: typeof LOAD_VISUAL_STYLES_FAILURE;
}
export const loadVisualStylesFailure = (): LoadVisualStylesFailureAction => ({
  type: LOAD_VISUAL_STYLES_FAILURE
});

export const ACTIVATE_VISUAL_STYLE_SEARCH = 'ACTIVATE_VISUAL_STYLE_SEARCH';

export interface ActivateVisualStyleSearchAction {
  type: typeof ACTIVATE_VISUAL_STYLE_SEARCH;
  facetId: string;
  facetValue: string;
}

export const activateVisualStyleSearch = ({
  facetId,
  facetValue
}: Omit<ActivateVisualStyleSearchAction, 'type'>): ActivateVisualStyleSearchAction => ({
  type: ACTIVATE_VISUAL_STYLE_SEARCH,
  facetId,
  facetValue
});

export interface NavigateToCharactersAction {
  type: typeof NAVIGATE_TO_CHARACTERS;
}
export const navigateToCharacters = (): NavigateToCharactersAction => ({
  type: NAVIGATE_TO_CHARACTERS
});

export interface NavigateBackFromCharactersAction {
  type: typeof NAVIGATE_BACK_FROM_CHARACTERS;
}
export const navigateBackFromCharacters = (): NavigateBackFromCharactersAction => ({
  type: NAVIGATE_BACK_FROM_CHARACTERS
});

export interface SelectCharacterAction {
  type: typeof SELECT_CHARACTER;
  characterName: string;
  characterStyle: CharacterStyle;
}

export const selectCharacter = (characterName: string, characterStyle: CharacterStyle): SelectCharacterAction => ({
  type: SELECT_CHARACTER,
  characterName,
  characterStyle
});
